var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStrategy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    enableBackground: "new 0 0 24 24",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0E1856",
    d: "M5.5,11L2,9V5l3.5-2L9,5v4L5.5,11z M5.5,8.7L7,7.8V6.1L5.5,5.3L4,6.1v1.7L5.5,8.7z M16.5,11.8V9.4l3.5,2v7 L14,22l-6-3.5v-7l3.5-2v2.3L10,12.6v4.7l4,2.3l4-2.3v-4.7L16.5,11.8z M13,14V2h9l-2,3l2,3h-7v6H13z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStrategy);
export default __webpack_public_path__ + "static/media/strategy.d7863c1fde0b57a077992364aa370d1d.svg";
export { ForwardRef as ReactComponent };